  
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { FindUsersResponse, Params } from "../../types/Types";

export function useFindUsers({
  enabled = true,
  pageSize = 10,
  page = 1,
  searchTerm,
  cities,
  sectors,
  turnovers,
  countries,
}: Params = {}) {
  return useQuery({
    enabled,
    queryKey: ['users', { pageSize, page, searchTerm, cities, sectors, turnovers, countries }],
    queryFn: async () => {
      let url = getAPIURL(`/User/All?pageNumber=${page}&pageSize=${pageSize}`);
      
      if (searchTerm) {
        url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
      }
      
      // Add multiple filter values as query parameters
      if (cities && cities.length > 0) {
        cities.forEach(city => {
          url += `&cities=${encodeURIComponent(city)}`;
        });
      }
      
      if (sectors && sectors.length > 0) {
        sectors.forEach(sector => {
          url += `&sectors=${encodeURIComponent(sector)}`;
        });
      }
      
      if (turnovers && turnovers.length > 0) {
        turnovers.forEach(turnover => {
          url += `&turnovers=${encodeURIComponent(turnover)}`;
        });
      }
      
      if (countries && countries.length > 0) {
        countries.forEach(country => {
          url += `&countries=${encodeURIComponent(country)}`;
        });
      }
      
      return axiosInstance<FindUsersResponse>(url).then((res) => res.data);
    },
  });
}